import { OrdersState } from "./ordersTypes";

export const initialState: OrdersState = {
  onlyToBePrinted: true,
  onlyTakeAway: false,
  searchQuery: "",
  selectedUserId: undefined,
  orders: [],
  fullOrders: [],
  loading: false,
  error: undefined,
  orderDetail: 0,
};
